/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const MediaPipelineStage = {
    Queued: 'Queued',
    Download: 'Download',
    VirusScan: 'VirusScan',
    Mezzanine: 'Mezzanine',
    Thumbnail: 'Thumbnail',
    Playback: 'Playback',
    HoverPreview: 'HoverPreview'
};
export function MediaPipelineStageFromJSON(json) {
    return MediaPipelineStageFromJSONTyped(json, false);
}
export function MediaPipelineStageFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function MediaPipelineStageToJSON(value) {
    return value;
}
